export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10544.abd496c0.jpg";